import { useNavigate } from "react-router-dom";
import TopNav from "../home/components/TopNav";

const plans = [
  {
    id: "basic",
    name: "基础版",
    price: "199",
    unit: "元/月",
    desc: "适合个人及小型团队",
    color: "slate",
    features: [
      "小区楼栋数据查询（每日50次）",
      "工业园区数据查询（每日20次）",
      "数据导出（Excel格式）",
      "基础字段展示",
      "邮件支持",
    ],
    disabled: ["高级分析字段", "批量导出", "API接口", "定制报告"],
    cta: "立即开通",
  },
  {
    id: "pro",
    name: "专业版",
    price: "699",
    unit: "元/月",
    desc: "适合企业及专业分析师",
    color: "emerald",
    badge: "最受欢迎",
    features: [
      "小区楼栋数据查询（不限次）",
      "工业园区数据查询（不限次）",
      "所有数据字段完整展示",
      "Excel / CSV / JSON 格式导出",
      "批量区域导出（每次最多500条）",
      "数据时效性标注",
      "专属客服支持",
    ],
    disabled: ["自定义 API 接口", "私有化部署"],
    cta: "立即升级",
  },
  {
    id: "enterprise",
    name: "企业版",
    price: "定制",
    unit: "",
    desc: "政府及大型企业专属方案",
    color: "slate",
    features: [
      "全量数据无限制访问",
      "专属 RESTful API 接口",
      "私有化部署支持",
      "数据定制采集与更新",
      "专属数据分析顾问",
      "SLA 服务保障 99.9%",
      "培训与实施支持",
    ],
    disabled: [],
    cta: "联系我们",
  },
];

export default function UpgradePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />

      {/* Hero */}
      <div className="pt-24 pb-12 px-8 text-center bg-gradient-to-b from-slate-50 to-white">
        <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-full px-4 py-1.5 mb-5">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-vip-crown-line text-emerald-600 text-sm"></i>
          </div>
          <span className="text-xs text-emerald-700 font-medium">解锁完整数据权限</span>
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-3">
          升级即可导出完整数据
        </h1>
        <p className="text-slate-500 text-base max-w-lg mx-auto leading-relaxed">
          您刚才查看的小区楼栋 / 工业园区数据已准备就绪。选择合适的方案，立即导出完整字段报告。
        </p>
      </div>

      {/* Plans */}
      <div className="max-w-5xl mx-auto px-8 pb-20">
        <div className="grid grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-2xl border overflow-hidden ${
                plan.badge
                  ? "border-emerald-400 ring-2 ring-emerald-200"
                  : "border-slate-200"
              }`}
            >
              {plan.badge && (
                <div className="absolute top-0 left-0 right-0 h-1 bg-emerald-400"></div>
              )}
              {plan.badge && (
                <div className="absolute top-3 right-4">
                  <span className="bg-emerald-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {plan.badge}
                  </span>
                </div>
              )}

              <div className="p-6">
                <h3 className="text-base font-bold text-slate-800 mb-1">{plan.name}</h3>
                <p className="text-xs text-slate-500 mb-4">{plan.desc}</p>
                <div className="flex items-baseline gap-1 mb-6">
                  <span className={`text-3xl font-bold ${plan.badge ? "text-emerald-600" : "text-slate-800"}`}>
                    {plan.price === "定制" ? "" : "¥"}{plan.price}
                  </span>
                  <span className="text-sm text-slate-500">{plan.unit}</span>
                </div>

                <button
                  onClick={() => {
                    if (plan.id === "enterprise") {
                      // scroll to bottom / contact
                    }
                  }}
                  className={`w-full py-2.5 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                    plan.badge
                      ? "bg-emerald-500 hover:bg-emerald-600 text-white"
                      : "bg-slate-100 hover:bg-slate-200 text-slate-800"
                  }`}
                >
                  {plan.cta}
                </button>
              </div>

              {/* Features */}
              <div className="px-6 pb-6 space-y-2">
                {plan.features.map((f) => (
                  <div key={f} className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className={`ri-check-line text-sm ${plan.badge ? "text-emerald-500" : "text-slate-500"}`}></i>
                    </div>
                    <span className="text-xs text-slate-700 leading-relaxed">{f}</span>
                  </div>
                ))}
                {plan.disabled.map((f) => (
                  <div key={f} className="flex items-start gap-2 opacity-40">
                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-close-line text-sm text-slate-400"></i>
                    </div>
                    <span className="text-xs text-slate-500 leading-relaxed">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 text-center">
          <p className="text-sm text-slate-400">
            所有方案均支持7天无理由退款 · 数据每季度更新 ·
            <button
              onClick={() => navigate("/")}
              className="text-emerald-600 hover:text-emerald-700 ml-1 cursor-pointer"
            >
              返回地图
            </button>
          </p>
        </div>

        {/* Export preview */}
        <div className="mt-12 rounded-2xl bg-slate-50 border border-slate-200 p-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-100">
              <i className="ri-file-excel-2-line text-emerald-600 text-lg"></i>
            </div>
            <div>
              <h4 className="text-sm font-bold text-slate-800">导出示例预览</h4>
              <p className="text-xs text-slate-500">升级后可导出完整字段 Excel / CSV 报告</p>
            </div>
          </div>
          <div className="overflow-x-auto rounded-lg border border-slate-200">
            <table className="w-full text-xs">
              <thead>
                <tr className="bg-slate-100">
                  {["小区名称","楼栋数","小区类型","封闭类型","总户数","容积率","绿化率","物业公司"].map((h) => (
                    <th key={h} className="px-3 py-2 text-left text-slate-600 font-semibold whitespace-nowrap border-r border-slate-200 last:border-r-0">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ["望京花园东区","24","住宅","全封闭","3,240","2.8","35.6%","望京物业"],
                  ["领秀新硅谷","18","住宅","半封闭","2,180","3.2","38.2%","领秀物业"],
                  ["南湖东园公寓","6","公寓","全封闭","680","4.5","28.3%","链家物业"],
                ].map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}>
                    {row.map((cell, j) => (
                      <td key={j} className="px-3 py-2 text-slate-700 border-r border-slate-100 last:border-r-0 whitespace-nowrap">{cell}</td>
                    ))}
                  </tr>
                ))}
                <tr className="bg-white">
                  {Array(8).fill("").map((_, j) => (
                    <td key={j} className="px-3 py-2 border-r border-slate-100 last:border-r-0">
                      <div className="h-3 rounded bg-slate-200"></div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-xs text-slate-400 mt-3 text-center">升级后可导出完整数据，上方演示数据仅供参考</p>
        </div>
      </div>
    </div>
  );
}
